/**
 * The ONLY way UI code turns an API failure into text (spec §8.1): a backend-authored
 * `error.message` string on a `{ success: false }` body, else the caller's fixed fallback.
 * Never render err.message / String(err) — that is how "Cannot read properties of…" leaks.
 */
export function getUserErrorMessage(
  response: unknown,
  fallback: string
): string {
  const r = response as
    { success?: unknown; error?: { message?: unknown } } | null | undefined;
  const msg = r && r.success === false ? r.error?.message : undefined;
  return typeof msg === 'string' && msg.trim() ? msg : fallback;
}
